import instance from '../utils/axios';

export const fetchBlockedEventTypes = async () => {
    const response = await instance.get('/api/blockmarket/event-types');
    return response.data;
};

export const blockUnblockEventType = async (data) => {
    const response = await instance.put('/api/blockmarket/event-types', data);
    return response.data;
}

export const fetchBlockedEvents = async (event_type) => {
    const response = await instance.get(`/api/blockmarket/events/${event_type}`);
    return response.data;
}


export const blockUnblockEvent = async (data) => {
    const response = await instance.put('/api/blockmarket/events', data);
    return response.data;
}

export const fetchBlockedMarketTypes = async (eventId) => {
    const response = await instance.get(`/api/blockmarket/market-types/${eventId}`);
    return response.data;
}

export const blockUnblockMarketType = async (data) => {
    const response = await instance.put('/api/blockmarket/market-types', data);
    return response.data;
}
